import './utils/NodelistForeachPolyfill';
import $ from 'jquery';
import 'jquery-trend';
import 'jquery-revealer';
import 'intersection-observer';
import RimgShopify from '@pixelunion/rimg-shopify';
import ShopifySectionsManager from '@pixelunion/shopify-sections-manager';
import PxsMap from '@pixelunion/pxs-map';
import PxsVideo from '@pixelunion/pxs-video';

import TemplateAccount from './templates/TemplateAccount';
import TemplateAddresses from './templates/TemplateAddresses';

import DynamicBlogPosts from './sections/DynamicBlogPosts';
import DynamicImagesWithText from './sections/DynamicImagesWithText';
import DynamicTestimonial from './sections/DynamicTestimonial';
import StaticAnnouncementBar from './sections/StaticAnnouncementBar';
import StaticCart from './sections/StaticCart';
import StaticCollection from './sections/StaticCollection';
import StaticFooter from './sections/StaticFooter';
import StaticGiftCard from './sections/StaticGiftCard';
import StaticHeader from './sections/StaticHeader';
import StaticPassword from './sections/StaticPassword';
import StaticProductRecommendations from './sections/StaticProductRecommendations';
import StaticSlideshow from './sections/StaticSlideshow';

import Accordion from './components/Accordion';
import GoogleMap from './components/GoogleMap';
import ProductDetails from './components/ProductDetails';
import RTE from './components/RTE';
import Select from './components/Select';
import Video from './components/Video';

import ThemeUtils from './utils/ThemeUtils';

// Flickity iOS fix
import flickityTouchFix from './utils/FlickityTouchFix';

export default class Launch {
  constructor() {
    const $body = $(document.body);

    this.themeUtils = ThemeUtils;

    RimgShopify.init();

    this.rteViews = [];
    this._richText();
    this.themeUtils.externalLinks($(document));

    this.sections = new ShopifySectionsManager();

    this.sections.register('pxs-map', section => new PxsMap(section));
    this.sections.register('pxs-video', section => new PxsVideo(section));

    this.sections.register('dynamic-blog-posts', section => new DynamicBlogPosts(section));
    this.sections.register('dynamic-images-with-text', section => new DynamicImagesWithText(section));
    this.sections.register('dynamic-testimonials', section => new DynamicTestimonial(section));
    this.sections.register('pxs-announcement-bar', section => new StaticAnnouncementBar(section));
    this.sections.register('static-cart', section => new StaticCart(section));
    this.sections.register('static-collection', section => new StaticCollection(section));
    this.sections.register('static-footer', section => new StaticFooter(section));
    this.sections.register('static-giftcard', section => new StaticGiftCard(section));
    this.sections.register('static-header', section => new StaticHeader(section));
    this.sections.register('static-password', section => new StaticPassword(section));
    this.sections.register('static-slideshow', section => new StaticSlideshow(section));
    this.sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));

    this.sections.register('faq', section => new Accordion(section));
    this.sections.register('map', section => new GoogleMap(section));
    this.sections.register('static-product', section => new ProductDetails(section));
    this.sections.register('dynamic-featured-product', section => new ProductDetails(section));
    this.sections.register('dynamic-alternating-content', section => new Video(section));

    if ($('select').length && !this.isProduct) {
      $('select').each((index, item) => new Select({ el: $(item) }));
    }

    if ($(document.body).hasClass('template-customers-addresses')) {
      new TemplateAddresses({ el: $body });
    }

    if ($(document.body).hasClass('template-customers-login')) {
      new TemplateAccount({ el: $body });
    }
  }

  inputPlaceholderFix() {
    const placeholders = $('[placeholder]');

    placeholders.each((index, inputValue) => {
      const input = $(inputValue);
      if (!(input.val().length > 0)) {
        const text = input.attr('placeholder');
        input.attr('value', text);
        input.data('original-text', text);
      }
    });

    placeholders.focus(() => {
      const input = $(this);
      if (input.val() === input.data('original-text')) {
        input.val('');
      }
    });

    placeholders.blur(() => {
      const input = $(this);
      if (input.val().length === 0) {
        input.val(input.data('original-text'));
      }
    });
  }

  _richText() {
    if (this.isPassword) { return; }

    $('.rte').map(rte => this.rteViews.push(new RTE({ el: rte })));
  }
}

flickityTouchFix();

$(() => { window.theme = new Launch(); });
